/**
 * Authentication Guard
 * 
 * Protects routes that require user authentication.
 * Redirects unauthenticated users to the login page.
 * 
 * @remarks
 * - Guard behavior is controlled by environment configuration
 * - In development, can be disabled via `environment.auth.enableGuards`
 * - Preserves the intended destination URL for post-login redirect
 */

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { RoutePaths } from '../constants';
import { environment } from '../../../environments/environment';

export const authGuard: CanActivateFn = (route, state) => {
  // Skip guard if disabled in environment config (for development)
  if (!environment.auth.enableGuards) {
    return true;
  }
  
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isLoggedIn()) {
    return true;
  }

  // Redirect to login page with return URL
  router.navigate([RoutePaths.LOGIN], {
    queryParams: { returnUrl: state.url }
  });
  return false;
};




